import {Component, Input} from '@angular/core';
import {DocumentNews} from '../model/document-news.model';

@Component({
  selector: 'news-item',
  templateUrl: './news-item.component.html'
})
export class NewsItemComponent {

  @Input()
  newsItem: DocumentNews;

}



// WEBPACK FOOTER //
// ./src/app/shared/news-widget/news-item.component.ts